import { Country } from "@pg-app/shared/models/country";
import { PaymentServiceProvider } from "./payment-service-provider";
import { Currency } from "@pg-app/shared/models/currency";
import { Bank } from "@pg-app/shared/models/bank";

export class NewApprovedPayer
{
    legalName?: string;
    payerType?: string;
    country?: Country;
    countryId?: string;
    address1?: string;
    address2?: string;
    city?: string;
    state?: string;
    postCode?: string;
    taxId?: string;
    currency?: Currency;
    currencyId?: string;
    isPSP: boolean;
    paymentServiceProvider?: PaymentServiceProvider;
    paymentServiceProviderId?: string;
    emailNotification: boolean;
    email?: string;
    phone?: string;
    payerBank?: Bank;
}